/**
 * Mapbox Layer
 * 
 * @Author: Focci
 * @Date: 2023-07-09 17:57:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-09 17:57:27
 */

'use client'

// import PropTypes from 'prop-types'
// import HighlightPolygon from './highlight-polygon'
import useProgressRouter from '@hook/useProgressRouter'
import { isFunction } from 'lodash-es'
import { useCallback } from 'react'
import { urls } from '@lib/parse'
import { houseSearchType } from '@lib/config'
import { useLocale } from 'next-intl'
import { RemoteLayers } from './RemoteLayers'
import HighlightSuburb from './highlight-suburb'
import { useMapState } from '..'

export default function MapboxLayer({
  children,
  type = houseSearchType.residential,
  apiParam,
  onLayerClick
}) {
  const mps = useMapState()
  const locale = useLocale()
  const { routerPush } = useProgressRouter()
  
  const handleHighlightSuburbClick = useCallback(({ newParam }) => {
    if(isFunction(onLayerClick)) {
      onLayerClick({ param: newParam, type })
    } else {
      const url = urls.listing(type, newParam, locale, true)
      routerPush(url)
    }
  }, [onLayerClick, type, locale, routerPush])
  
  return (
    <>
      {/* Suburb polygon */}
      {mps.suburbShadow.status > 0 && (
        <HighlightSuburb 
          data={apiParam} 
          onHighlightSuburbClick={handleHighlightSuburbClick} 
        />
      )}
      <RemoteLayers />
      {children}
    </>
  )
}
